export default "__VITE_ASSET__C06Kj8eT__"